var exports = {
  "mc": "Container__ca3x-_",
  "Zv": "Pane__mp9bK0",
  "DF": "MainContent__RJzih4",
};

module.exports = exports;
